//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

  props: {
    //對應的區塊名稱
    blockCode: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: false,
      default: "37.5vw"
    },
    boxStyle: {
      type: String,
      required: false
    },
    imgShadow: {
      type: Boolean,
      required: false,
      default: false
    },
    listData: {
      //外部數據
      type: Array,
      required: false
    },
    bannershow: {
      type: Boolean,
      required: false
      // default:true
    },
    topIsSearchBar: {
      type: Boolean,
      required: false,
      default:false
    }
  },
  data() {
    return {
      index: 0,
      showDots: false, // 默認不顯示，當圖片超過1個的時候顯示
      listD: [],
      targetConfig: {
        column: "detail",
        video: "videoDetail",
        audio: "audioDetail",
        ebook: "ebookGuide",
        packSale: "recommendSalesList",
        flashSale: "flashSalesList",
        activityList: "activityList",
        signCalendar: "signCalendar",
        memberGift: "memberGift"
      },
      load: true,
      load_banner: true,
      targetL: {
        //跳轉地址配置
        column: {
          path: "detail",
          params: [{ name: "id", label: "id"}] //跳轉所需參數
        },
        video: {
          path: "videoDetail",
          params: [{ name: "id", label: "id"}]
        },
        audio: {
          path: "audioDetail",
          params: [{ name: "id", label: "id"}]
        },
        ebook: {
          path: "ebookDetail",
          params: [{ name: "id", label: "id"}]
        }
      }
    };
  },
  computed: {},
  methods: {
    onIndexChange(index) {
      this.index = index;
    },

    //點擊跳轉事件
    bannerClicked(ind) {
      console.log('listData',this.listData);
      let item = this.listData[ind].bookRel;
      console.log('item',item);
      let types = item.columnCode; //类型
      let dataType = item.dataType; //专辑还是详情
      let target = this.targetL[types];
      if(dataType == 'medialist'){
        target = this.targetL['column'];
      }else{
        target = this.targetL[types];
      }
      if (target == undefined) {
        //未配置的目標地址
        // console.log("error", "未配置的目標地址");
        return;
      }
      let pArr = target.params;
      let q = {};
      let obj = {};
      obj["path"] = target.path;
      console.log('pArr',pArr);
      pArr.forEach(p => {
        let val = item[p.name];
        //如果有傳入LABLE則，使用LABEL作為屬性值，沒有則使用name作為參數值
        let key = p.label ? p.label : p.name;
        q[key] = val;
      });

      obj["query"] = q;
      //console.log(obj, q);
      this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
    },
    //過濾無圖片的
    screening(res) {
      let listDRes = [];
      res.forEach(item => {
        let i = {
          url: "javascript:"
        };
        //新
        if (item.bookRel && item.bookRel.authCoverUrl) {
          i.img = item.bookRel.authCoverUrl;
        } else {
          i.img = null;
        }

        if (i.img) listDRes.push(i);
      });
      this.load_banner = false;
      this.listD = listDRes;
      // console.log(listDRes, "listDRes");
    }
  },
  mounted() {

  },
  watch: {
    listData: {
      handler() {
        if (this.listData.length > 0) {
          //外部傳遞數據
          //console.log(this.listData, "外部傳遞數據");
          // this.listD=this.listData;
          this.screening(this.listData);
        }
      },
      deep: true,
      immediate: true
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/banner.vue